import { Navigate, Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import { useAuthStore } from "@reframe-mobile/features/auth/store";
import { LoadingOverlay } from "@reframe-mobile/components/ui/loading";

function ProtectedRoute() {
  const { user, status, init } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (status === "idle") {
      void init();
    }
  }, [init, status]);

  if (status === "loading") {
    return <LoadingOverlay />;
  }

  if (status === "success" && !user) {
    return <Navigate to="/login" />;
  }

  if (user && !user.onboardingCompleted && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" />;
  }

  if (user && user.onboardingCompleted && location.pathname === "/onboarding") {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
